var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpscaler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upscaler__prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upscaler__prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.19 12.071H9.945a.75.75 0 000 1.5h4.247q.726 0 1.236-.515.505-.512.505-1.235v-10q0-.725-.512-1.237Q14.907.07 14.182.07h-10q-.724 0-1.237.513-.513.512-.513 1.237v4.244a.75.75 0 101.5 0V1.82q0-.25.25-.25h10q.25 0 .25.25v10q0 .25-.241.25zm-6.028-9.39h4.322a.75.75 0 01.527.216l.003.003c.141.14.22.332.22.53v4.323a.75.75 0 01-1.5 0V5.24L9.098 7.877a.75.75 0 11-1.06-1.06l2.635-2.637H8.162a.75.75 0 010-1.5zM.068 14.196V9.793q0-.718.507-1.225.507-.508 1.225-.508h4.404q.717 0 1.225.508.507.507.507 1.225v4.404q0 .717-.507 1.225-.508.507-1.225.507H1.8q-.718 0-1.225-.507-.507-.508-.507-1.225zm1.484 0q0 .247.248.247h4.404q.247 0 .247-.247V9.793q0-.248-.247-.248H1.8q-.248 0-.248.248v4.404z",
    fillRule: "evenodd",
    fill: "#414751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpscaler);
export default __webpack_public_path__ + "static/media/upscaler.1ae6067b5d00f71c9d8ab2b835893ad7.svg";
export { ForwardRef as ReactComponent };